import styled from 'styled-components';
import { LegendLabel as LegendLabelComponent } from '@vx/legend';

import { CHART_SUBTITLE_COLOR } from '../../../utils/colors';
import { media } from '../../../utils/media';

export const LegendContainer = styled.div`
  margin-left: auto;
  display: flex;

  ${media.tablet`
    margin-left: unset;
  `}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;

  :first-child {
    margin-left: 0;
  }
`;

export const LegendLabel = styled(LegendLabelComponent)`
  font-family: sans-serif;
  font-size: 0.75em;
  line-height: 1em;
  color: ${CHART_SUBTITLE_COLOR};
`;

export const legendLabelStyle = {
  margin: '0 0 0 7px',
};

export const legendItemStyle = {
  margin: '0 0 4px 0',
};
